const countries = require('../assets/countries/countries.json');

const allCountries = Object.keys(countries).reduce(
  (prev, next) =>
    prev.concat({
      code: next,
      callingCode: countries[next].callingCode,
      flag: countries[next].flag,
      name: countries[next].name.common,
    }),
  []
);

export function countryCodeAndFlagSelected(code, type = null) {
  const indexCountry = allCountries.findIndex(e =>
    type ? e[type] === code : e.code === code
  );
  const flagSelected = indexCountry !== -1 ? allCountries[indexCountry] : null;

  if (flagSelected) {
    return flagSelected;
  }
  return false;
}

export function findFlag(code, isCodeValue = false) {
  if (!code) return null;

  if (isCodeValue) {
    const index = allCountries.findIndex(e => e.code === code);
    return allCountries[index].flag;
  }

  const index = allCountries.findIndex(e => e.callingCode === code);
  return allCountries[index].flag;
}
